// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import AutosaveFieldController from "./autosave_field_controller"
application.register("autosave-field", AutosaveFieldController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import CoreValueEditController from "./core_value_edit_controller"
application.register("core-value-edit", CoreValueEditController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import GoalEditController from "./goal_edit_controller"
application.register("goal-edit", GoalEditController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import IconPickerController from "./icon_picker_controller"
application.register("icon-picker", IconPickerController)

import InlineAddCoreValueController from "./inline_add_core_value_controller"
application.register("inline-add-core-value", InlineAddCoreValueController)

import InlineAddGoalController from "./inline_add_goal_controller"
application.register("inline-add-goal", InlineAddGoalController)

import InlineAddProjectController from "./inline_add_project_controller"
application.register("inline-add-project", InlineAddProjectController)

import InlineAddRoleController from "./inline_add_role_controller"
application.register("inline-add-role", InlineAddRoleController)

import InlineConfirmController from "./inline_confirm_controller"
application.register("inline-confirm", InlineConfirmController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import InlineNewGoalController from "./inline_new_goal_controller"
application.register("inline-new-goal", InlineNewGoalController)

import InlineNewProjectTaskController from "./inline_new_project_task_controller"
application.register("inline-new-project-task", InlineNewProjectTaskController)

import InlineNewRoleController from "./inline_new_role_controller"
application.register("inline-new-role", InlineNewRoleController)

import InlineNewTaskController from "./inline_new_task_controller"
application.register("inline-new-task", InlineNewTaskController)

import LoadingController from "./loading_controller"
application.register("loading", LoadingController)

import NotesController from "./notes_controller"
application.register("notes", NotesController)

import NotesSortableController from "./notes_sortable_controller"
application.register("notes-sortable", NotesSortableController)

import PanelToggleController from "./panel_toggle_controller"
application.register("panel-toggle", PanelToggleController)

import ProfileNavController from "./profile_nav_controller"
application.register("profile-nav", ProfileNavController)

import ProjectExpandController from "./project_expand_controller"
application.register("project-expand", ProjectExpandController)

import ProjectSelectController from "./project_select_controller"
application.register("project-select", ProjectSelectController)

import QuickScheduleController from "./quick_schedule_controller"
application.register("quick-schedule", QuickScheduleController)

import RecurrenceFormController from "./recurrence_form_controller"
application.register("recurrence-form", RecurrenceFormController)

import RecurringDeleteController from "./recurring_delete_controller"
application.register("recurring-delete", RecurringDeleteController)

import RoleEditController from "./role_edit_controller"
application.register("role-edit", RoleEditController)

import RoleFormController from "./role_form_controller"
application.register("role-form", RoleFormController)

import SectionNameController from "./section_name_controller"
application.register("section-name", SectionNameController)

import SectionsSortableController from "./sections_sortable_controller"
application.register("sections-sortable", SectionsSortableController)

import SnoozeMenuController from "./snooze_menu_controller"
application.register("snooze-menu", SnoozeMenuController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import StatusMenuController from "./status_menu_controller"
application.register("status-menu", StatusMenuController)

import TaskDragController from "./task_drag_controller"
application.register("task-drag", TaskDragController)

import TaskTagsController from "./task_tags_controller"
application.register("task-tags", TaskTagsController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleCompletedController from "./toggle_completed_controller"
application.register("toggle-completed", ToggleCompletedController)

import UserActiveController from "./user_active_controller"
application.register("user-active", UserActiveController)
